// extracted by mini-css-extract-plugin
module.exports = {"favoritesLink":"FavoritesIcon_favoritesLink__mrb26","leftToRight":"FavoritesIcon_leftToRight__QK_KM"};